// extracted by mini-css-extract-plugin
export var customShapeDividerTop1634433982 = "waveSection-module--custom-shape-divider-top-1634433982--1PvaQ";
export var svgTrans = "waveSection-module--svgTrans--VQh1_";